import styled from 'styled-components';

export const InputDefault = styled.input`
  border-color: ${props =>
    props.appearence === 'error' ? '#f27576' : '#e1e1e1'} !important;
`;
